export interface PersistedEvidenceItemExportRow {
    evidenceName: string;
    statusLabel: string;
    requirementKeys: string[];
    assignedUserLabel: string;
    hasLinkedSecureStorageFile: boolean;
}

const escapeCsvCell = (value: string): string => `"${value.replace(/"/g, '""')}"`;

const getExportRequirementLabel = (row: PersistedEvidenceItemExportRow): string =>
    row.requirementKeys.join(", ") || "All in-scope requirements";

const getLinkedFileLabel = (row: PersistedEvidenceItemExportRow): string =>
    row.hasLinkedSecureStorageFile ? "Linked Secure Storage file" : "No linked file";

export const buildPersistedEvidenceItemCopyText = (rows: readonly PersistedEvidenceItemExportRow[]): string => rows
    .map((row) => [
        `Evidence: ${row.evidenceName}`,
        `Status: ${row.statusLabel}`,
        `Requirements: ${getExportRequirementLabel(row)}`,
        `Assigned users: ${row.assignedUserLabel}`,
        `File: ${getLinkedFileLabel(row)}`
    ].join("\n"))
    .join("\n\n");

export const buildPersistedEvidenceItemCsv = (rows: readonly PersistedEvidenceItemExportRow[]): string => {
    const header = ["Evidence", "Status", "Requirements", "Assigned users", "Linked file"]
        .map(escapeCsvCell)
        .join(",");
    const body = rows.map((row) => [
        row.evidenceName,
        row.statusLabel,
        getExportRequirementLabel(row),
        row.assignedUserLabel,
        getLinkedFileLabel(row)
    ].map(escapeCsvCell).join(","));

    return `\uFEFF${[header, ...body].join("\r\n")}`;
};
